import Vuex from 'vuex'
import Vue from 'vue'
import themeConfig from './modules/themeConfig'
import authData from './modules/authData'
import verticalSidebar from './modules/verticalSidebar'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
  state: {
    loginerror: '',
    error: '',
    userprofiles: [],
    auditlog: [],
    alerts: [],
    isloading: '',
    ccsites: [],
    user: '',
    stackerevents: [],
    paymentCredentials: '',
    loadedwalletusers: [],
    grouppickups: [],
    groupcitvalues: [],
    rels: [],
    groupbalance: 0,
    weatherdata: [],
    depositImages: [],
    tickets: [],
    ssunits: [],
    citevents: [],
    ccsites: [],
    kcsites: [],
    nssites: [],
    transactionDetail: '',
    seqfeeddata: [],
    pinglist: [],
    sssites: [],
    namsyssites: [],
    fieods: [],
    splitdata: [],
    presplitdata: [],
    systemdata: '',
    sitecashinvalues: [],
    cashingroupvalues: [],
    checkedPackages: [],
    checkedDetail: '',
    shipmentDetail: '',
    heartbeatvalues: [],
    loginerror: '',
    notereaderjamlist: [],
    notereaderjams: [],
    notereadereventlist: [],
    notereaderevents: [],
    sitecashbalance: [],
    sites: [],
    montheod: [],
    estateSafeData: [],
    realtimebalances: [],
    sitedeposits: [],
    sitecashinvalues: [],
    userdeposits: [],
    systemevents: [],
    securebag: [],
    manualdeposits: [],
    estatesums: [],
    locationcashin: [],
    usergroups: [],
    userinstitutions: [],
    VirtualRates: [],
    SmartSafeRates: [],
    loadedSites: [],
    sitebalancevalues: [],
    postaldeposits: [],
    postalbags: [],
    postalorders: [],
    postalshipments: [],
    GroupShipments: [],
    inhouseshipments: [],
    changeorders: [],
    billingconfigs: [],
    billingclients: [],
    seqDataPublished: [],
    changeschedules: [],
    filledorders: [],
    changeprofiles: [],
    billingprofiles: [],
    pendingdeposits: [],
    completeddeposits: [],
    grosspostaldeposits: '',
    grossvalidated: '',
    grosssumbyday: '',
    postalchecks: [],
    mlresults: [],
    mlinstdata: [],
    aidataAnalysis: '',
    dtsdeposits: [],
    alerts: [],
    feedData: '',
    feedSSData: '',
    aivaultdata: [],
    aivaultcontext: [],
    depositusers: [],
    siteprofiles: [],
    sitebalancevalues: '',
    manualdeposits: [],
    packages: [],
    userprofile: '',
    userprofiles: [],
    currentuserwallets: '',
    safes: [],
    // estatesums: [],
    safe_transactions: [],
    estatenotecount: [],
    keyfobs: [],
    isloading: '',
    systemsnap: '',
    postdeposits: '',
    dailytotals: null,
    isDimebankSite: false,
    isChaseAEGSite: false,
    checkResponseData: ''

  },
  getters,
  actions,
  mutations,
  modules: {
    themeConfig,
    authData,
    verticalSidebar,
  },
})
